'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var extractInfoFromUrl_util = require('./extract-info-from-url.util.js');

function getCdnFromS3UrlFactory(config) {
    return (url, params) => {
        const { getCdnUrl } = config;
        const info = extractInfoFromUrl_util.extractInfoFromUrl(url);
        if (info === undefined) {
            return url;
        }
        const { instanceId, path } = info;
        return getCdnUrl(instanceId, path, params);
    };
}

exports.getCdnFromS3UrlFactory = getCdnFromS3UrlFactory;
//# sourceMappingURL=get-cdn-from-s3-url.util.js.map
